// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3QAG6","buttons":"PendingPaymentAlert_buttons__3NOKz"};